import { History, Route, ShieldCheck, UserCheck } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Section, SectionHead } from "./Reveal";

const ICONS = { shield: ShieldCheck, route: Route, history: History, user: UserCheck };

export const Governance = () => {
  const { t } = useLang();

  return (
    <Section id="governanca" className="scanlines">
      <SectionHead label={t.gov.label} title={t.gov.heading} sub={t.gov.sub} />
      <div className="grid gap-5 md:grid-cols-2">
        {t.gov.cards.map((c, i) => {
          const Icon = ICONS[c.icon];
          return (
            <Reveal key={c.title} delay={(i % 2) * 0.08} className="h-full">
              <div
                data-testid={`governance-card-${i + 1}`}
                className="group h-full rounded-xl border border-line bg-ink-900/60 p-8 transition-all duration-300 hover:border-volt/30 hover:bg-ink-800"
              >
                <div className="flex items-center gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-volt/25 bg-volt/10">
                    <Icon size={18} className="text-volt" />
                  </span>
                  <h3 className="font-display text-xl font-bold tracking-tight">{c.title}</h3>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-mist">{c.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.1}>
        <figure
          data-testid="governance-quote"
          className="mt-14 max-w-4xl rounded-2xl border border-line bg-ink-900/50 p-8 md:p-10"
        >
          <blockquote className="font-display text-xl font-bold leading-snug tracking-tight md:text-2xl">
            “{t.gov.quote}”
          </blockquote>
          <figcaption className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-white/45">
            {t.gov.quoteBy}
          </figcaption>
        </figure>
      </Reveal>
    </Section>
  );
};
